module.exports = __webpack_public_path__ + "img/faillq.63a15916.svg";